module.exports = __webpack_public_path__ + "img/shape-3-mobile-gold@2x.2115837c.png";